import React from 'react';
import {
  Heading,
  HeadingUnderLine,
  ActiveTabBox,
  SeparateContainer,
  SeparateInnerContainer,
  FlexContainer,
  Scores,
  LevelNameText,
} from '../styles';
import { CodeWrittenText } from '../components/styles';

export default function testCases({ bestRunInput, totalScore, totalMaxScore }) {
  let correctnessLevels = bestRunInput?.levelScores?.slice(
    0,
    bestRunInput.levelScores.length - bestRunInput.goodPerformanceScores.length
  );

  let correctnessLevelsName = bestRunInput?.levelNames?.slice(
    0,
    bestRunInput.levelNames.length - bestRunInput.levelScores.length - bestRunInput.goodPerformanceScores.length
  );

  let performanceLevels = bestRunInput?.levelScores?.slice(
    bestRunInput.levelScores.length - bestRunInput.goodPerformanceScores.length,
    bestRunInput.levelScores.length
  );

  let performanceLevelsName = bestRunInput?.levelNames?.slice(
    bestRunInput.levelNames.length - bestRunInput.goodPerformanceScores.length,
    bestRunInput.levelNames.length
  );

  const getPerformanceScore = function (index) {
    return typeof bestRunInput.performanceScores[index] === 'number' &&
      bestRunInput.performanceScores[index] <= bestRunInput.goodPerformanceScores[index]
      ? bestRunInput.performanceScores[index] + ' ms'
      : 'Timeout';
  };

  const getCorrectnessLevelScoreBoxColor = (levelScore, index) => {
    const calc = levelScore / bestRunInput.levelMaxScores[index];
    if (bestRunInput.levelScores[index] === 0) return 'bad';
    if (calc * 100 > 0 && calc * 100 <= 25) return 'poor';
    if (calc * 100 > 25 && calc * 100 <= 50) return 'fair';
    if (calc * 100 > 50 && calc * 100 <= 75) return 'good';
    if (calc * 100 > 75) return 'excellent';
  };

  const getGoodPerformanceLevelScoreBoxColor = (index) => {
    const calc = bestRunInput.performanceScores[index];
    if (typeof calc !== 'number' || calc >= bestRunInput.goodPerformanceScores[index]) return 'bad';
    if (typeof calc === 'number' && calc < bestRunInput.goodPerformanceScores[index]) return 'excellent';
  };

  const getPerformanceLevelScoreBoxScore = (index) => {
    const calc =
      performanceLevels[index] /
      bestRunInput.levelMaxScores[bestRunInput.levelMaxScores.length - performanceLevels.length - 1 + index];
    if (performanceLevels[index] === 0) return 'bad';
    if (calc * 100 > 0 && calc * 100 <= 25) return 'poor';
    if (calc * 100 > 25 && calc * 100 <= 50) return 'fair';
    if (calc * 100 > 50 && calc * 100 <= 75) return 'good';
    if (calc * 100 > 75) return 'excellent';
  };

  const getTotalScoreBoxScore = () => {
    const calc = (totalScore / totalMaxScore) * 100;
    if (totalScore === 0) return 'bad';
    if (calc > 0 && calc <= 25) return 'poor';
    if (calc > 25 && calc <= 50) return 'fair';
    if (calc > 50 && calc <= 75) return 'good';
    if (calc > 75) return 'excellent';
  };

  const renderTestCases = () => {
    return (
      <>
        {correctnessLevels.length && (
          <>
            <CodeWrittenText>Correctness test cases:</CodeWrittenText>
            {correctnessLevels.map((levels, index) => {
              return (
                <FlexContainer key={`correctnessLevels${index}`} alignItemsCenter={true}>
                  <LevelNameText>{correctnessLevelsName[index]}</LevelNameText>
                  <Scores color={getCorrectnessLevelScoreBoxColor(levels, index)}>{`${levels} / ${
                    bestRunInput.levelMaxScores[index] ?? 1
                  }`}</Scores>
                </FlexContainer>
              );
            })}
          </>
        )}
        {performanceLevels.length && (
          <>
            <CodeWrittenText>Performance test cases:</CodeWrittenText>
            {performanceLevels.map((levels, index) => {
              return (
                <FlexContainer key={`performanceLevels${index}`} alignItemsCenter={true}>
                  <LevelNameText>
                    {performanceLevelsName[index]} (Max time limit: {`${bestRunInput.goodPerformanceScores[index]} ms`})
                  </LevelNameText>
                  <FlexContainer alignItemsCenter={true}>
                    <Scores color={getGoodPerformanceLevelScoreBoxColor(index)} marginRight={'2px'}>
                      {getPerformanceScore(index)}
                    </Scores>
                    <Scores color={getPerformanceLevelScoreBoxScore(index)}>{`${levels} / ${
                      bestRunInput.levelMaxScores[
                        bestRunInput.levelMaxScores.length - bestRunInput.performanceScores.length - 1 + index
                      ]
                    }`}</Scores>
                  </FlexContainer>
                </FlexContainer>
              );
            })}
          </>
        )}
        {correctnessLevels.length + performanceLevels.length && (
          <FlexContainer alignItemsCenter={true} marginTop={'20px'}>
            <CodeWrittenText>Total:</CodeWrittenText>
            <Scores color={getTotalScoreBoxScore()}>{`${totalScore} / ${totalMaxScore}`}</Scores>
          </FlexContainer>
        )}
      </>
    );
  };

  return (
    <SeparateContainer extraBoxWithShadow={true}>
      <SeparateInnerContainer extraBoxWithShadow={true}>
        <ActiveTabBox>
          <Heading>TEST CASES - BEST SCORING CODE</Heading>
          <HeadingUnderLine />
          {renderTestCases()}
        </ActiveTabBox>
      </SeparateInnerContainer>
    </SeparateContainer>
  );
}
